var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlusDefault2828 = function SvgPlusDefault2828(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#949596",
    fillRule: "evenodd",
    d: "M12.9 15.1V25h2.2v-9.9H25v-2.2h-9.9V3h-2.2v9.9H3v2.2z",
    clipRule: "evenodd"
  })));
};
export default SvgPlusDefault2828;